"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _effects = require("redux-saga/effects");

var _commonConstants = require("../../../utils/common-constants");

var _action = require("../../notification/action");

var _actions = require("./actions");

var _constants = require("./constants");

var _service = require("./service");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(applicationWatcher),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(applicationWorker),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(scopesWatcher),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(scopesWorker),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(EnvironmentsWatcher),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(environmentsWorker);

function applicationWatcher() {
  return regeneratorRuntime.wrap(function applicationWatcher$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeLatest)(_constants.ApplicationType.APPLICATION_REQUEST, applicationWorker);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function applicationWorker(_ref) {
  var payload, appID, response, _response$data, _response, reason;

  return regeneratorRuntime.wrap(function applicationWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          appID = payload;
          _context2.prev = 2;
          _context2.next = 5;
          return (0, _effects.call)(_service.fetchAppDetails, appID);

        case 5:
          response = _context2.sent;
          _context2.next = 8;
          return (0, _effects.put)((0, _actions.applicationRequestSuccess)(response));

        case 8:
          _context2.next = 18;
          break;

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](2);
          _response = _context2.t0.response;
          reason = (_response === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : _response$data.message) || '';
          _context2.next = 16;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, reason, true, _commonConstants.errorNotificationDuration));

        case 16:
          _context2.next = 18;
          return (0, _effects.put)((0, _actions.applicationRequestFailure)(reason));

        case 18:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[2, 10]]);
}

function scopesWatcher() {
  return regeneratorRuntime.wrap(function scopesWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_constants.ScopesType.SCOPES_REQUEST, scopesWorker);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function scopesWorker(_ref3) {
  var payload, papID, response, _response2$data, _response2, reason;

  return regeneratorRuntime.wrap(function scopesWorker$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          papID = payload;
          _context4.prev = 2;
          _context4.next = 5;
          return (0, _effects.call)(_service.fetchScopes, papID);

        case 5:
          response = _context4.sent;
          _context4.next = 8;
          return (0, _effects.put)((0, _actions.scopesRequestSuccess)(response));

        case 8:
          _context4.next = 18;
          break;

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](2);
          _response2 = _context4.t0.response;
          reason = (_response2 === null || _response2 === void 0 ? void 0 : (_response2$data = _response2.data) === null || _response2$data === void 0 ? void 0 : _response2$data.message) || '';
          _context4.next = 16;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, reason, true, _commonConstants.errorNotificationDuration));

        case 16:
          _context4.next = 18;
          return (0, _effects.put)((0, _actions.scopesRequestFailure)(reason));

        case 18:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[2, 10]]);
}

function EnvironmentsWatcher() {
  return regeneratorRuntime.wrap(function EnvironmentsWatcher$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_constants.EnvironmentsType.ENVIRONMENTS_REQUEST, environmentsWorker);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function environmentsWorker(_ref5) {
  var payload, appID, response, _response3$data, _response3, reason;

  return regeneratorRuntime.wrap(function environmentsWorker$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _ref5.payload;
          appID = payload;
          _context6.prev = 2;
          _context6.next = 5;
          return (0, _effects.call)(_service.fetchEnvironments, appID);

        case 5:
          response = _context6.sent;
          _context6.next = 8;
          return (0, _effects.put)((0, _actions.environmentsRequestSuccess)(response));

        case 8:
          _context6.next = 18;
          break;

        case 10:
          _context6.prev = 10;
          _context6.t0 = _context6["catch"](2);
          _response3 = _context6.t0.response;
          reason = (_response3 === null || _response3 === void 0 ? void 0 : (_response3$data = _response3.data) === null || _response3$data === void 0 ? void 0 : _response3$data.message) || '';
          _context6.next = 16;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, reason, true, _commonConstants.errorNotificationDuration));

        case 16:
          _context6.next = 18;
          return (0, _effects.put)((0, _actions.environmentsRequestFailure)(reason));

        case 18:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[2, 10]]);
}

var _default = (0, _effects.all)([(0, _effects.fork)(applicationWatcher), (0, _effects.fork)(scopesWatcher), (0, _effects.fork)(EnvironmentsWatcher)]);

exports.default = _default;